import Alpine from 'alpinejs';

Alpine.data('poItems', (items = []) => ({
    items,

    add(fk_bm_id, poi_description, poi_qty = 0, poi_satuan = 'kg', poi_sub_total = 0, poi_id = '') {
        if (this.items.filter(item => item.fk_bm_id == fk_bm_id).length) {
            return;
        }

        this.items.push({
            fk_bm_id, poi_description,
            poi_qty, poi_satuan, poi_sub_total, poi_id
        });
    },

    remove(item) {
        this.items = this.items.filter(data => data.fk_bm_id != item.fk_bm_id);
    },

    clear() {
        this.items = [];
    },

    sum() {
        const
            total = this.items.reduce((total, item) => total + Number(item.poi_sub_total), 0),
            formatter = new Intl.NumberFormat(
                'id',
                {
                    style: 'currency',
                    currency: 'IDR'
                }
            );

        return formatter.format(Number(total));
    },
}));
